import React from "react";

const ConnectedWhatsAppLoader = props => {
  const { count = 1 } = props || {};

  return Array.from({ length: count }, (value, index) => (
    <div
      className="connectedLinkedInCard inboxRowloader"
      key={`waRowloader${index}`}
    >
      <div className="profileInformation">
        <div className="leftLayout">
          <div className="imgType linear-background" />
        </div>
        <div className="wrapConnectedEmail">
          <div className="userName linear-background" />
          <div className="connectedEmail linear-background" />
        </div>
      </div>
      <div className="warmerMetricsWrapper linear-background" />
      <div className="btnInboxActions">
        <div className="configureBtn linear-background" />
        <div className="deleteInboxIcon linear-background" />
      </div>
    </div>
  ));
};

export { ConnectedWhatsAppLoader };
export default ConnectedWhatsAppLoader;
